import type { QueryClient } from '@tanstack/react-query'
import { analyticHypothesisKeys } from '@/features/analytic-hypotheses/queries'
import { getOrCreateInvestigationsStore } from '@/stores/investigations-store'
import type { Investigation } from '@/types/investigation'

/**
 * After research saved an investigation (a finding, a report): the investigations list
 * refetches, the hypothesis it is evidence for shows it (ADR-0095), and the Zustand store
 * the investigation pages read gets it at once — it does not share react-query's cache.
 */
export function syncSavedInvestigation(qc: QueryClient, caseId: string, inv: Investigation) {
  qc.invalidateQueries({ queryKey: ['investigations', caseId] })
  if (inv.hypothesisRef) {
    qc.invalidateQueries({ queryKey: analyticHypothesisKeys.one(caseId, inv.hypothesisRef) })
  }
  getOrCreateInvestigationsStore({ caseId }).getState().upsertSaved(inv)
}
